export default __webpack_public_path__ + "static/media/tabicon.e41670a0.png";